import { create, destroy } from '@dojo/framework/core/vdom';

import { documentTitleUpdate, lccstate } from '..';

export interface TrackedDocument {
	title: string;
}

export interface DocumentAPI {
	tracked: TrackedDocument;
	setup(): void;
	setDocument(): void;
	setTitle(newTitle: string): void;
}

const factory = create({ destroy, lccstate });
export const documentapi = factory(({ middleware: { destroy, lccstate } }) => {
	const { get, path } = lccstate;

	const handles: any[] = [];
	destroy(() => {
		let handle: any;
		while ((handle = handles.pop())) {
			handle();
		}
	});

	const api: DocumentAPI = {
		tracked: {
			title: get(path('title'))
		},

		setup(): void {
			this.setDocument();
			const store = lccstate.getStore();
			const { path } = store;
			const handle = store.onChange([path('title')], () => {
				this.setDocument();
			});
			handles.push(() => handle.remove());
		},

		setDocument(this: DocumentAPI): void {
			const { title } = this.tracked;
			if (document.title !== title) {
				document.title = title;
			}
		},

		setTitle(this: DocumentAPI, newTitle?: string): void {
			const hcstatic = window.hcstatic;
			const { association_name: assoc } = hcstatic;
			const product = get(path('product'));
			if (newTitle) {
				const title = `${assoc?.toUpperCase()} - ${product.toUpperCase()} - ${newTitle}`;
				this.tracked.title = title;
				documentTitleUpdate({ title });
			}
		}
	};

	api.setup();
	return api;
});
